import { api } from '@/shared/api'
import type { Skins } from '@/shared/game/types'

export type ShopItem = {
  code: string
  kind: keyof Skins
  /** Название присылает сервер: каталог у него. */
  title: string
  price: number
  owned: boolean
  equipped: boolean
}

export type Showcase = {
  coins: number
  items: ShopItem[]
  equipped: Skins
}

export async function fetchShop(): Promise<Showcase> {
  const { data } = await api.get<Showcase>('/me/shop')

  return data
}

export async function buyItem(code: string): Promise<Showcase> {
  const { data } = await api.post<Showcase>(`/me/shop/${code}/buy`)

  return data
}

/** Надеть купленное или снять (code = null). */
export async function equipItem(kind: keyof Skins, code: string | null): Promise<Showcase> {
  const { data } = await api.post<Showcase>('/me/shop/equip', { kind, code })

  return data
}
